import { gridSize, gridSizeMdLg2, gridSizeMdLg4 } from "@/shared"
import { CustomAutocomplete, CustomTextField, TabTextLabel } from "@/shared/components/ui"
import { Grid, Paper } from "@mui/material"
import ModalProductoComponete from "../ModalProductoComponente/ModalProductoComponente"
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination"
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store"
import useTableColumnsRegistroFacturas from "../../hook/useTableColumnsRegistroFacturas"
import useRegistroFacturas from "../../hook/useRegistroFacturas"
import { IVA, MaterialTransferido } from "@/shared/interfaces"
import { FieldError, useFormContext, useWatch } from "react-hook-form"
import { useEffect } from "react"


export default function RegistroFacturaOrdenCompra() {
  const { control, setValue, getValues, formState: { errors } } = useFormContext();
  //store_prodcuto
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const handldeAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  //
  ///console.log('productos', productos)
  //hook
  const {
    infoProducto,
  } = useTableColumnsRegistroFacturas()

  const {
    //form, errors,
    ivaResp, isLoadinIva
  } = useRegistroFacturas()

  //
  const costo = useWatch({ control, name: "costo_otro" });
  const iva_porcentaje = useWatch({ control, name: "iva_otro_porcentaje" });

  useEffect(() => {
    const costoNum = Number(costo);

    // Extraer solo el número del porcentaje (ej: "IVA 15%" → 15)
    const ivaNum = Number(String(iva_porcentaje).replace(/[^0-9.]/g, ""));


    if (isNaN(costoNum) || isNaN(ivaNum)) return;

    if (!costoNum || !ivaNum) {
      setValue("iva_otro", "0");
      setValue("total_otro", "0");
      return
    }
    const iva_otro = costoNum * (ivaNum / 100)
    const total_otro = costoNum + iva_otro
    setValue('costo_otro', Number(costoNum))

    setValue("iva_otro", iva_otro.toFixed(2))
    setValue("total_otro", total_otro.toFixed(2))

  }, [costo, iva_porcentaje, setValue]);

  return (
    <>
      <Grid item {...gridSize}>
        <Paper className="paper-producto">
          <Grid container spacing={1} justifyContent={"space-between"} alignItems={"center"}>
            <Grid item>
              <TabTextLabel text="Productos Seleccionados" mt={0} pb={0} pl={0} pt={0} />
            </Grid>

            <Grid item>
              <ModalProductoComponete
                onChange={(e) => {
                  //console.log('e', e.nombre)
                  //subtotal_producto = 
                  const aux: MaterialTransferido = {
                    id: e.id_producto || e.id_gasto || e.id_costo,
                    codigo: e.codigo,
                    cantidad: '1',
                    cuentas_contables: e.cuentas_contables,
                    precio_compra: '0',
                    descuento: '0',
                    contiene_serie: e.contiene_serie,
                    producto_data: {
                      codigo: e.codigo,
                      categoria_producto: e.categoria_producto,
                      subcategoria_producto: e.subcategoria_producto,
                      descripcion: e.id_producto ? e.descripcion : e.nombre,
                      unidad_medida: e.unidad_medida,
                      presentacion: e.presentacion
                    },
                    series: [],
                    costo: e.costo,
                    cif:e.cif,
                    mano_obra_directa:e.mano_obra_directa,
                    mano_obra_indirecta: e.mano_obra_indirecta,
                    subtotal_descuento: '0.00',
                    iva_producto: '0.00',
                    total_producto: '0.00',
                    iva_porcentaje: e.iva,
                    ice: e.ice
                  }
                  handldeAgregarProducto(aux)
                }}
              />
            </Grid>
            {/*tabla que indica los prodctos*/}
            <div className="linea" />
            <Grid item xs={12}>

              <SampleTablePagination
                columns={infoProducto}
                data={paginatedData}
                pagination={pagination}
                setPagination={setPagination}
                rowCount={productos.length}
              />
              <TabTextLabel text="otros" />
              <Paper variant="outlined" sx={{ p: 3, }} >
                <Grid container spacing={1} >
                  <CustomTextField
                    label="Descripción"
                    name="descripcion_otro"
                    control={control}
                    error={!!errors.descripcion_otro}
                    helperText={errors.descripcion_otro?.message as string}
                    size={gridSizeMdLg4}
                  />
                  <CustomTextField
                    label="SubTotal Sin IVA"
                    name="costo_otro"
                    control={control}
                    error={!!errors.costo_otro!}
                    helperText={errors.costo_otro?.message as string}
                    size={gridSizeMdLg2}
                    onChangeValue={e => {
                      setValue('costo_otro', e)
                    }}
                    type="number"
                  />
                  <CustomAutocomplete<IVA>
                    label="Iva porcentaje"
                    name="iva_otro_porcentaje"
                    options={ivaResp?.data.data || []}
                    isLoadingData={isLoadinIva}
                    valueKey={"nombre"}
                    actualValueKey="codigo"
                    defaultValue={getValues().iva_otro_porcentaje || ''}
                    control={control}
                    error={errors.iva_otro_porcentaje as FieldError | undefined}
                    helperText={errors.iva_otro_porcentaje?.message as string}
                    size={gridSizeMdLg2}
                    onChangeValue={e => {
                      //console.log('iva',e)
                      setValue('iva_otro_porcentaje', e)
                    }}
                  />
                  <CustomTextField
                    label="Iva"
                    name="iva_otro"
                    control={control}
                    error={!!errors.iva_otro}
                    helperText={errors.iva_otro?.message as string}
                    size={gridSizeMdLg2}
                  />
                  <CustomTextField
                    label="Total"
                    name="total_otro"
                    control={control}
                    error={!!errors.total_otro}
                    helperText={errors.total_otro?.message as string | undefined}
                    size={gridSizeMdLg2}
                  />
                </Grid>
              </Paper>


            </Grid>

          </Grid>

        </Paper>

      </Grid>
    </>
  )
}